import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { needsEmailVerification, rememberPostVerifyPath } from '../utils/emailVerification';
import { useVendorStatus } from '../hooks/useVendorStatus';
import { Box, CircularProgress } from '@mui/material';

const ACCOUNT_LOCKED_PATH = '/app/account-locked';

const fullPageSpinner = (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh"
  >
    <CircularProgress />
  </Box>
);

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { currentUser, loading, isAdmin } = useAuth();
  const { isRejected, isLoading: statusLoading } = useVendorStatus();
  const location = useLocation();

  if (loading) {
    return fullPageSpinner;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (needsEmailVerification(currentUser)) {
    rememberPostVerifyPath(`${location.pathname}${location.search}`);
    return <Navigate to="/verify-email" replace />;
  }

  if (!isAdmin && statusLoading) {
    return fullPageSpinner;
  }

  if (!isAdmin && isRejected && location.pathname !== ACCOUNT_LOCKED_PATH) {
    return <Navigate to={ACCOUNT_LOCKED_PATH} replace />;
  }

  return <>{children}</>;
};
